import designSystemPreset from './design-system-preset';

const appConfig = {
    icon: {
        // customize: (content: string, name: string, prefix: string, provider: string) => {
        //     return content
        //         .replace(/stroke-width="[^"]*"/g, `stroke-width="2"`) // Change stroke width to 2
        //         .replace(/stroke="[^"]*"/g, `stroke="#355e3b"`) // Change stroke color to red
        //         .replace(/fill="[^"]*"/g, `fill="#355e3b"`) // Change fill color to red
        //         .replace(/animation-duration="[^"]*"/g, `animation-duration="1s"`) // Change animation duration to 1s (for animated icons)
        //         // .replace(/opacity="[^"]*"/g, `opacity="0.8"`);// Change opacity to 0.8            
        // }
    },
    ui: {
        colorMode: false,
        // Semantic roles map to color scales from ui-design-system/src/css/theme.css.
        colors: {
            primary: 'primary',
            secondary: 'secondary',
            neutral: 'neutral',
            success: 'success',
            warning: 'warning',
            error: 'danger',
            info: 'accent',
        },
        ...designSystemPreset,
        // Breadcrumb - active item stays black, not primary color
        breadcrumb: {
            variants: {
                active: {
                    true: {
                        link: 'text-muted font-semibold'
                    }
                }
            }
        },
        // Override Nuxt UI prose paragraph defaults for markdown ContentRenderer output.
        prose: {
            p: {
                base: 'my-5 leading-6 text-pretty'
            }
        }
    }
}
export default defineAppConfig(appConfig);